const tables = [
  {
    name: "Number",
  },
  {
    name: "Supplier",
  },
  {
    name: "Date",
  },
  {
    name: "Due",
  },
  {
    name: "Delivery",
  },
  {
    name: "Payment",
  },
  {
    name: "Amount",
  },
  {
    name: "Action",
  },
];

export default tables;
